/**
 * @Description 益禾堂预估销售额2.0
 * https://confluence.lanhanba.com/pages/viewpage.action?pageId=132271748
 */

import { FC, useEffect, useState } from 'react';
import { Form, Col } from 'antd';
import {
  estimateSalesReasonableSelectYHT,
  estimateSalesSafetySelectYHT,
  estimateSalesUpLimitSelectYHT,
  estimateSalesUpLimitYHT,
  insiderEstimateSalesYHT,
  meituanCompetitorAverageYHT,
  meituanCompetitorMaxYHT,
  setComValue
} from '../../config';
import { estimatedDailyIdentification } from '../../customize';
import { isNotEmpty } from '@lhb/func';
import { useMethods } from '@lhb/hook';
// import cs from 'classnames';
// import styles from './entry.module.less';
import V2FormInputNumber from '@/common/components/Form/V2FormInputNumber/V2FormInputNumber';
import V2FormSelect from '@/common/components/Form/V2FormSelect/V2FormSelect';
import V2Message from '@/common/components/Others/V2Hint/V2Message';

interface EstimateSalesYHTProps {
  form: any;
  propertyItem: any;
  required: boolean;
  tiledFormDataRef: any;
  disabled?: boolean;
  // wholeFormData: any;
};
const EstimateSalesYHT: FC<EstimateSalesYHTProps> = ({
  propertyItem,
  required,
  form,
  tiledFormDataRef,
  disabled,
  // wholeFormData,
}) => {
  const estimateSalesVal = Form.useWatch(estimatedDailyIdentification, form);
  const estimateSalesUpLimitVal = Form.useWatch(estimateSalesUpLimitYHT.keyValue, form);
  const insiderEstimateSalesVal = Form.useWatch(insiderEstimateSalesYHT.keyValue, form);
  const meituanCompetitorAverageVal = Form.useWatch(meituanCompetitorAverageYHT.keyValue, form);
  const meituanCompetitorMaxVal = Form.useWatch(meituanCompetitorMaxYHT.keyValue, form);
  const [options, setOptions] = useState<any[]>([]); // 选项值

  useEffect(() => {
    const targetOptions: any = [];
    if (isNotEmpty(estimateSalesVal)) {
      // 取label值
      const targetCom = tiledFormDataRef?.current?.find((item) => item.identification === estimatedDailyIdentification);
      targetOptions.push({
        label: `${estimateSalesVal}元（${targetCom?.anotherName || targetCom?.name || '营业额预估值'}）`,
        value: estimatedDailyIdentification,
        detailShowVal: `${estimateSalesVal}元（${targetCom?.anotherName || targetCom?.name || '营业额预估值'}）`,
        countValue: estimateSalesVal, // 服务端用
      });
    }
    if (isNotEmpty(estimateSalesUpLimitVal)) {
      targetOptions.push({
        label: `${estimateSalesUpLimitVal}元（${estimateSalesUpLimitYHT.label}）`,
        value: estimateSalesUpLimitYHT.keyValue,
        detailShowVal: `${estimateSalesUpLimitVal}元（${estimateSalesUpLimitYHT.label}）`,
        countValue: estimateSalesUpLimitVal, // 服务端用
      });
    }
    if (isNotEmpty(insiderEstimateSalesVal)) {
      targetOptions.push({
        label: `${insiderEstimateSalesVal}元（${insiderEstimateSalesYHT.label}）`,
        value: insiderEstimateSalesYHT.keyValue,
        detailShowVal: `${insiderEstimateSalesVal}元（${insiderEstimateSalesYHT.label}）`,
        countValue: insiderEstimateSalesVal, // 服务端用
      });
    }
    if (isNotEmpty(meituanCompetitorAverageVal)) {
      targetOptions.push({
        label: `${meituanCompetitorAverageVal}元（${meituanCompetitorAverageYHT.label}）`,
        value: meituanCompetitorAverageYHT.keyValue,
        detailShowVal: `${meituanCompetitorAverageVal}元（${meituanCompetitorAverageYHT.label}）`,
        countValue: meituanCompetitorAverageVal, // 服务端用
      });
    }
    if (isNotEmpty(meituanCompetitorMaxVal)) {
      targetOptions.push({
        label: `${meituanCompetitorMaxVal}元（${meituanCompetitorMaxYHT.label}）`,
        value: meituanCompetitorMaxYHT.keyValue,
        detailShowVal: `${meituanCompetitorMaxVal}元（${meituanCompetitorMaxYHT.label}）`,
        countValue: meituanCompetitorMaxVal, // 服务端用
      });
    }
    setComValue(propertyItem, {
      options: targetOptions
    });
    setOptions(targetOptions);
  }, [estimateSalesVal, estimateSalesUpLimitVal, insiderEstimateSalesVal, meituanCompetitorAverageVal, meituanCompetitorMaxVal]);

  useEffect(() => {
    methods.checkTarget(estimatedDailyIdentification);
  }, [estimateSalesVal]);

  useEffect(() => {
    methods.checkTarget(estimateSalesUpLimitYHT.keyValue);
  }, [estimateSalesUpLimitVal]);

  const methods = useMethods({
    handleNumInputChange: (val: any, key: string) => {
      setComValue(propertyItem, {
        [key]: val
      });

      methods.checkTarget(key);
    },
    checkTarget: (key: string) => {
      const a = form.getFieldValue(estimateSalesUpLimitSelectYHT.keyValue);
      const b = form.getFieldValue(estimateSalesReasonableSelectYHT.keyValue);
      const c = form.getFieldValue(estimateSalesSafetySelectYHT.keyValue);
      if ((key === a || key === b || key === c) && !methods.checkSelectVal()) {
        form.setFieldValue(estimateSalesUpLimitSelectYHT.keyValue, null);
        form.setFieldValue(estimateSalesReasonableSelectYHT.keyValue, null);
        form.setFieldValue(estimateSalesSafetySelectYHT.keyValue, null);
        setComValue(propertyItem, {
          [estimateSalesUpLimitSelectYHT.keyValue]: null,
          [estimateSalesReasonableSelectYHT.keyValue]: null,
          [estimateSalesSafetySelectYHT.keyValue]: null
        });
        V2Message.warning('需满足「营业额预估上限值」≥「营业额预估合理值」≥「营业额预估保底值」，请重新选择');
      }
    },
    checkSelectVal: () => {
      let targetAVal = 0;
      let targetBVal = 0;
      let targetCVal = 0;
      const targetA = form.getFieldValue(estimateSalesUpLimitSelectYHT.keyValue);
      const targetB = form.getFieldValue(estimateSalesReasonableSelectYHT.keyValue);
      const targetC = form.getFieldValue(estimateSalesSafetySelectYHT.keyValue);
      if (targetA) {
        targetAVal = form.getFieldValue(targetA);
      }
      if (targetB) {
        targetBVal = form.getFieldValue(targetB);
      }
      if (targetC) {
        targetCVal = form.getFieldValue(targetC);
      }
      if (targetAVal >= targetBVal && targetBVal >= targetCVal) {
        return true;
      }
      return false;
    },
    handleSelectChange: (val: any, key: string) => {
      if (methods.checkSelectVal()) {
        setComValue(propertyItem, {
          [key]: val
        });
        return;
      }
      V2Message.warning('选择的值应该满足「营业额预估上限值」≥「营业额预估合理值」≥「营业额预估保底值」');
      form.setFieldValue(key, '');
    },
  });
  return (
    <>
      <Col span={12}>
        <V2FormInputNumber
          label={estimateSalesUpLimitYHT.label}
          name={estimateSalesUpLimitYHT.keyValue}
          placeholder='选择详细地址后自动获取'
          required={required}
          disabled={true}
          config={{
            addonAfter: '元'
          }}
        />
      </Col>
      <Col span={12}>
        <V2FormInputNumber
          label={insiderEstimateSalesYHT.label}
          name={insiderEstimateSalesYHT.keyValue}
          placeholder='输入内容'
          max={999999999}
          required={required}
          disabled={disabled}
          config={{
            addonAfter: '元',
          }}
          onChange={(val: any) => methods.handleNumInputChange(val, insiderEstimateSalesYHT.keyValue)}
        />
      </Col>
      <Col span={12}>
        <V2FormInputNumber
          label={meituanCompetitorAverageYHT.label}
          name={meituanCompetitorAverageYHT.keyValue}
          placeholder='输入内容'
          max={999999999}
          required={required}
          disabled={disabled}
          config={{
            addonAfter: '元'
          }}
          onChange={(val: any) => methods.handleNumInputChange(val, meituanCompetitorAverageYHT.keyValue)}
        />
      </Col>
      <Col span={12}>
        <V2FormInputNumber
          label={meituanCompetitorMaxYHT.label}
          name={meituanCompetitorMaxYHT.keyValue}
          placeholder='输入内容'
          max={999999999}
          required={required}
          disabled={disabled}
          config={{
            addonAfter: '元'
          }}
          onChange={(val: any) => methods.handleNumInputChange(val, meituanCompetitorMaxYHT.keyValue)}
        />
      </Col>
      {/* 选择  */}
      <Col span={12}>
        <V2FormSelect
          label={estimateSalesUpLimitSelectYHT.label}
          name={estimateSalesUpLimitSelectYHT.keyValue}
          placeholder='请选择'
          options={options}
          disabled={disabled}
          required={required}
          onChange={(val) => methods.handleSelectChange(val, estimateSalesUpLimitSelectYHT.keyValue)}
        />
      </Col>
      <Col span={12}>
        <V2FormSelect
          label={estimateSalesReasonableSelectYHT.label}
          name={estimateSalesReasonableSelectYHT.keyValue}
          placeholder='请选择'
          options={options}
          required={required}
          disabled={disabled}
          onChange={(val) => methods.handleSelectChange(val, estimateSalesReasonableSelectYHT.keyValue)}
        />
      </Col>
      <Col span={12}>
        <V2FormSelect
          label={estimateSalesSafetySelectYHT.label}
          name={estimateSalesSafetySelectYHT.keyValue}
          placeholder='请选择'
          options={options}
          required={required}
          disabled={disabled}
          onChange={(val) => methods.handleSelectChange(val, estimateSalesSafetySelectYHT.keyValue)}
        />
      </Col>
    </>
  );
};

export default EstimateSalesYHT;
